<template>
  <a @click="handleClick" :href="product ? null : href" class="ah-icon-link">
    <img class="ah-icon-link-img" :src="icon.src" :alt="icon.description"/>
    <span class="ah-icon-link-label">{{ label }}</span>
  </a>
</template>

<script>
  export default {
    name: 'IconLink',
    props: {
      href: String,
      label: String,
      product: Number,
      icon: {
        type: Object,
        default: function () {
          return {
            src: '',
            description: '',            
          }
        }
      }
    },
    methods: {
      handleClick: function(event) {
        event.preventDefault()
        if (!this.product) {
          window.location.href = this.href
        } else {
          window.cart.addProduct(this.product)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_variablesAH.scss";

  .ah-icon-link {
    text-decoration: none;
    display: flex;
    align-items: center;
    width: max-content;
    cursor: pointer;
  }
  .ah-icon-link-img {
    max-width: 16px;
    max-height: 16px;
  }
  .ah-icon-link-label {
    color: $blue-a;
    font-family: $font-main;
    font-size: 16px;
    padding-left: 6px;
  }
</style>